import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Spinner } from "reactstrap";
import { useAuth, IS_CUSTOM_AUTH } from "auth/useAuth";

const Authmiddleware = (props) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return (
      <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
        <Spinner color="primary" />
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    if (IS_CUSTOM_AUTH) {
      // Remember where the user was heading so /login can send them back.
      return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
    }
    // Hosted UI: hand off to Cognito directly.
    auth.signinRedirect();
    return <div>Redirecionando para o login...</div>;
  }

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;
